export const Paths = {
  Home: '/',
  HowItWorks: '/how-it-works',
  About: '/about',
  CaseStudies: '/case-studies',
  Faq: '/faq',
  SignIn: '/sign-in',
  SignUp: '/sign-up',
  PrivacyPolicy: '/privacy-policy',
  TermsOfUse: '/terms-of-use',
  Contact: '/contact',
  Case1Guide: '/case-1-guide',
  Case2Guide: '/case-2-guide',
  Case3Guide: '/case-3-guide',
  UserGuide: '/user-guide',
  RequestVerification: '/request-verification',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
  Profile: '/profile',
  Analyze: '/analyze',
};
